import StoreList from '@/data/store/view/list.vue'
import StoreEditor from '@/data/store/view/editor.vue'

const list = {
  path: '/store',
  name: 'store-list',
  component: StoreList
}
const creator = {
  path: '/store/creator',
  name: 'createStore',
  component: StoreEditor
}
const editor = {
  path: '/store/editor/:id(\\d+)',
  name: 'updateStore',
  component: StoreEditor
}

export default [list, creator, editor]
